import { Controller } from '@hotwired/stimulus';
import { SearchesMixin } from '../../../../mixins/searches_mixin';
import { post, destroy } from "@rails/request.js";

export default class extends Controller {
  static targets = [
    'searchWrapper',
    'invoiceIdHiddenInput',
    'invoiceLockVersionHiddenInput'
  ];

  initialize() {
    SearchesMixin(this, "Invoices::Contractor")

    this.initializeSearch(
      {
        selector: this.searchWrapperTarget,
        query: {},
        noResultsMessage: "Nie znaleziono pasujących wyników",
      },
      this.searchCallbacks(),
      this.customResultsTemplate(),
    );
  }

  customResultsTemplate() {
    return {
      standard: (response) => {
        return `
          ${this.renderResults(response)}
          ${this.addContractorButtonTemplate()}
        `
      },
      message: (message, type) => {
        return `
          <div class="result">
            ${$.fn.search.settings.templates.message(message, type).replaceAll('No Results', 'Brak')}
          </div>
          ${this.addContractorButtonTemplate()}
        `
      }
    }
  }

  addContractorButtonTemplate() {
    return `
      <div
        class="menu-item add-contractor"
        href="/panel/invoices/${this.invoiceIdHiddenInputTarget.value}/contractors/new"
        data-action="click->${this.identifier}#openAddContractorModal"
      >
        <div class="result text-blue">
          <i class="plus circle icon blue"></i>
          <a>Dodaj kontrahenta</a>
        </div>
      </div>
    `
  }

  openAddContractorModal(event) {
    event.preventDefault()
    const invoiceId = this.invoiceIdHiddenInputTarget.value
    const url = `/panel/invoices/${invoiceId}/contractors/new`

    window.Siepomaga.RemoteModal.prototype.openModal('get', url, false, true)
  }

  renderResults(response) {
    return response.results.map(object => `
      <div class="result">
        ${this.nameWithIcon(object)}
        ${this.renderConditionally(object, 'tax_identifier', 'NIP')}
        ${this.renderConditionally(object, 'address', 'Adres')}
        ${this.renderConditionally(object, 'keywords', 'Słowa kluczowe')}
        ${this.renderConditionally(object, 'id', 'ID')}
      </div>
    `).join('')
  }

  nameWithIcon(object) {
    const name = `Nazwa: ${object['name']}`;
    if (!object['status']) return `<div class="description black">${name}</div>`;

    const iconColor = object['status'] === 'warning' ? 'yellow' : 'red';

    return `<div class="description black">${name}
      <i class="warning sign icon ${iconColor}"/>
      </div>`;
  }

  renderConditionally(object, field, prefix) {
    if (object[field]) return `<div class="description black">${prefix}: ${object[field]}</div>`;

    return '';
  }

  searchCallbacks() {
    return {
      minCharacters: 3,
      maxResults: 1000,
      onSelect: (result) => {
        if (!result.id) return;

        const invoiceId = this.invoiceIdHiddenInputTarget.value;
        const invoiceLockId = this.invoiceLockVersionHiddenInputTarget.value;
        // FIXME: refactor links in this file as values from helpers?
        const url = `/panel/invoices/${invoiceId}/contractor_assignments`
        post(
          url, {
            body: { contractor_assignment: { contractor_id: result.id, lock_version: invoiceLockId } },
            headers: { Accept: "text/vnd.turbo-stream.html" }
          }
        )
      },
    };
  }

  clearContractor() {
    const invoiceId = this.invoiceIdHiddenInputTarget.value;
    const invoiceLockId = this.invoiceLockVersionHiddenInputTarget.value;
    const url = `/panel/invoices/${invoiceId}/contractor_assignments`

    destroy(
      url,
      {
        body: { contractor_assignment: { lock_version: invoiceLockId } },
        headers: { Accept: "text/vnd.turbo-stream.html" } },
    )
  }
}
